import { AnimatePresence } from 'framer-motion';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { ThemeContext } from 'styled-components';
import { LiquidIDAddPromptWrapper, StyledTitle, StyledButton, ThumbnailsMessage } from './styles';
import { setLiquidIDFaceSelection } from '@/store/slices';
import { setNFTManagerPanelOpen } from '@/store/actions/nft-manager';
import { useAppDispatch } from '@/hooks';
import YatTextReveal from '@/components/Sections/Profile/TextReveal';

interface Props {
    hidden: boolean;
}

const LiquidIDAddPrompt = ({ hidden }: Props) => {
    const theme = useContext(ThemeContext);
    const dispatch = useAppDispatch();
    const { t } = useTranslation(['yat_page']);

    const handleClick = () => {
        dispatch(setLiquidIDFaceSelection(0));
        dispatch(setNFTManagerPanelOpen());
    };

    return (
        <AnimatePresence>
            {!hidden && (
                <LiquidIDAddPromptWrapper
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: theme.transitions.speeds.fast, ease: theme.transitions.eases.cubic }}
                >
                    <StyledTitle type="headline" size={91}>
                        <YatTextReveal text={t('liquid_id_add_prompt_title')} />
                    </StyledTitle>
                    <StyledButton size="large" onClick={handleClick}>
                        {t('liquid_id_add_identity')}
                    </StyledButton>
                    <ThumbnailsMessage size={12} type="paragraph">
                        {t('liquid_id_add_nfts_message')}
                    </ThumbnailsMessage>
                </LiquidIDAddPromptWrapper>
            )}
        </AnimatePresence>
    );
};

export default LiquidIDAddPrompt;
